import comp from "./MealMapping";
export default comp;
